import React from 'react';
import styled, { CSSObject } from '@emotion/styled';
import merge from 'lodash.merge';
import { motion } from 'framer-motion';
import { BLACK_50 } from '@/ui-kit/theme';
import { useDialogContext } from '../dialog-context';

interface IStyledOverlayProps {
  isDisabled: boolean;
}

const StyledOverlay = styled(motion.div)<IStyledOverlayProps>(({ isDisabled }) => {
  let styles: CSSObject = {
    cursor: 'pointer',
    position: 'fixed',
    zIndex: 101,
    top: 0,
    left: 0,
    width: '100dvw',
    height: '100dvh',
    background: BLACK_50,
  };

  if (isDisabled) {
    const disabledStyles: CSSObject = { cursor: 'default' };
    styles = merge(styles, disabledStyles);
  }

  return styles;
});

const overlayVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      duration: 0.15,
      ease: 'easeOut',
    },
  },
  exit: {
    opacity: 0,
    transition: {
      duration: 0.15,
      ease: 'easeIn',
    },
  },
};

export const Overlay = () => {
  const {
    isSelfClosingDisabled,
    onClose,
  } = useDialogContext();

  return (
    <StyledOverlay
      isDisabled={isSelfClosingDisabled}
      onClick={isSelfClosingDisabled ? undefined : onClose}
      variants={overlayVariants}
      initial="hidden"
      animate="visible"
      exit="exit"
    />
  );
};
